import { Button, Col, Row, Typography } from "antd";
import React from "react";

const { Text } = Typography;

interface StopConfirmationContentProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const StopConfirmationContent: React.FC<StopConfirmationContentProps> = ({ message, onConfirm, onCancel }) => (
  <>
    <Text>{message}</Text>
    <br />
    <Row justify="center" gutter={12} style={{ paddingTop: 12 }}>

      <Col>
        <Button type="primary" onClick={onCancel}>
          No
        </Button>
      </Col>
      <Col>
        <Button type="primary" onClick={onConfirm}>
          Yes
        </Button>
      </Col>
    </Row>
  </>
);

export default StopConfirmationContent;